import useFormikTouchErrors from '../../../Hooks/useFormikTouchErrors';

const FormikTouchErrors = () => {
    useFormikTouchErrors();
    return null; // no-ui
};

export default FormikTouchErrors;
